import {
    BUTTON_SIZE,
    BUTTON_TYPE,
} from '@helpers/constants'
import Button from '@components/Button'
import classNames from 'classnames'
import { getImageSrc } from '@helpers/utilities'
import BlockRenderer from '@views/BlockRenderer'

const ExerciseBlock = ({ onShowPanel, name, preamble, image, children }) => {
    const isWordExplanation = !onShowPanel

    return (
        <div className={'bg-lightGrey p-7 rounded-md whitespace-pre-line'}>
            <>
                <div className={`w-full flex ${!isWordExplanation ? 'justify-center' : ''}`}>
                    <div
                        className={`${image && !isWordExplanation ? 'pr-7' : ''} w-2/3 flex flex-col ${!isWordExplanation ? 'items-center' : ''}`}
                    >
                        <div className={classNames('', {
                            'text-center': !isWordExplanation,
                            'mb-4': !preamble,
                        })}>
                            <BlockRenderer content={name} />
                        </div>
                        {preamble &&
                            <div className={`mb-4 self-stretch`}>
                                <BlockRenderer content={preamble} />
                            </div>
                        }
                        {!isWordExplanation &&
                            <div className={'mt-auto'}>
                                <Button
                                    handleClick={onShowPanel}
                                    type={BUTTON_TYPE.PRIMARY}
                                    size={BUTTON_SIZE.LARGE}
                                >
                                    Starta
                                </Button>
                            </div>
                        }
                    </div>
                    {image && (
                        <div className='w-1/3 self-start'>
                            <div className={'w-full pb-[100%] relative'}>
                                <img
                                    className={'absolute w-full h-full object-cover '}
                                    src={getImageSrc(image)}
                                    alt=''
                                />
                            </div>
                        </div>
                    )}
                </div>
            </>
            {isWordExplanation &&
                <div>
                    {children}
                </div>
            }
        </div>
    )
}

export default ExerciseBlock